import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useFetcher } from 'react-router-dom'

import ConfirmDeleteDialog from '@components/shared/dialogs/ConfirmDeleteDialog'
import { useDialogStore } from '@stores/dialog.store'

import type Collection from '@models/Collection'

const DeleteCollectionDialog: React.FC = () => {
  const { t } = useTranslation()
  const state = useDialogStore<Collection>((s) => s.state)
  const closeDialog = useDialogStore((s) => s.closeDialog)
  const fetcher = useFetcher()

  const [submitting, setSubmitting] = useState(false)
  useEffect(() => {
    if (submitting && fetcher.state === 'idle') {
      closeDialog('confirm_delete_collection')
      setSubmitting(false)
    }
  }, [submitting, fetcher.state, closeDialog])

  return (
    <ConfirmDeleteDialog
      title={t('action.deleteCollection')}
      message={t('messages.confirmDeleteCollection', { name: state?.name })}
      name="confirm_delete_collection"
      okDisabled={submitting}
      onConfirm={() => {
        if (state) {
          fetcher.submit(
            { collectionId: `${state.id}` },
            { method: 'post', action: '/home/deleteCollection' }
          )
          setSubmitting(true)
        }
      }}
    />
  )
}

export default DeleteCollectionDialog
